export default "__VITE_ASSET__Duymr8NS__"